module.exports = __webpack_public_path__ + "static/homescreen-e37d6b7d0b702fa1918e34a5fda87a62.png";